import React, { useState, useEffect } from "react";
import axios from "axios";
import dayjs from 'dayjs';
import { apiUrl } from "../../utility/Connections";
import "./formEvaluation.css";
import { Input, Button, Typography, Space, Row, Col, Select, Tooltip, DatePicker, InputNumber, Tag, Radio, message, Form } from "antd";
import { DeleteOutlined, EyeOutlined, PlusOutlined, QuestionCircleOutlined, SyncOutlined, UploadOutlined } from "@ant-design/icons";
import FileUploaderAuto from "../fileUploader/fileUploaderAuto";
import LoadingOverlay from "../loadingOverlay/loadingOverlay";
import TableCompetenceAnswerGroupRelation from "../tableCompetenceAnswerGroupRelation/tableCompetenceAnswerGroupRelation";
import TableAttributeAnswerGroupRelation from "../tableAttributeAnswerGroupRelation/tableAttributeAnswerGroupRelation";
import TableRelationships from "../tableRelationships/tableRelationships";
import TableEvaluationQuestions from "../tableEvaluationQuestions/tableEvaluationQuestions";

const { Text, Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;

const colorsConfig = [
    { color: 'red', label: 'Rojo', minKey: 'evl_min_red_light', maxKey: 'evl_max_red_light' },
    { color: 'yellow', label: 'Amarillo', minKey: 'evl_min_yellow_light', maxKey: 'evl_max_yellow_light' },
    { color: 'green', label: 'Verde', minKey: 'evl_min_green_light', maxKey: 'evl_max_green_light' },
    { color: 'cyan', label: 'Azul', minKey: 'evl_min_blue_light', maxKey: 'evl_max_blue_light' },
];

const FormEvaluation = ({ data, dataCompetencies, dataEvaluationAnswerGroups, dataEmployees, setData, relEvlCmpEag, setRelEvlCmpEag, onSave, onCancel, showSwal, type }) => {
    const [showLoading, setShowLoading] = useState(false);
    const [loadingText, setLoadingText] = useState(null);
    const [fileCharged, setFileCharged] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileChargedQuestions, setFileChargedQuestions] = useState(false);
    const [selectedFileQuestions, setSelectedFileQuestions] = useState(null);
    // const [relEvlCmpEag, setRelEvlCmpEag] = useState([]);
    const [isWeightValid, setIsWeightValid] = useState(true);

    //Agregar relaciones
    const [evaluated, setEvaluated] = useState("");
    const [evaluator, setEvaluator] = useState("");
    const [evrType, setEvrType] = useState("");

    const [evaluatedInfo, setEvaluatedInfo] = useState(null);
    const [evaluatorInfo, setEvaluatorInfo] = useState(null);

    const [tableTitle, setTableTitle] = useState("");
    const [autoQuestionTitle, setAutoQuestionTitle] = useState("");
    const [autoQuestionText1, setAutoQuestionText1] = useState("");
    const [autoQuestionText2, setAutoQuestionText2] = useState("");

    //Agregar preguntas
    const [question, setQuestion] = useState("");
    const [questionText, setQuestionText] = useState("");

    useEffect(() => {
        const updatedRelations = [...relEvlCmpEag];
        
        dataCompetencies.forEach((cmp) => {
            let exists
            if (type === "competencies") {
                exists = relEvlCmpEag.some(rel => rel.cmp_id === cmp.cmp_id);
            } else if (type === "leadership") {
                exists = relEvlCmpEag.some(rel => rel.cmp_id === cmp.lat_id);
            }
            
            if (!exists) {
                if (type === "competencies") {
                    updatedRelations.push({
                        cmp_id: cmp.cmp_id,
                        name: cmp.cmp_competence,
                        description: cmp.cmp_description,
                        eag_id: null,
                        weight: null,
                        evl_id: data.evl_id ?? null,
                    });
                } else if (type === "leadership") {
                    updatedRelations.push({
                        cmp_id: cmp.lat_id,
                        name: cmp.lat_attribute,
                        description: cmp.lat_description,
                        eag_id: null,
                        weight: null,
                        evl_id: data.evl_id ?? null,
                    });
                }
            }
        });

        if (type === "competencies") {
            setTableTitle("Competencia")
            setAutoQuestionTitle("Configuración de competencias");
            setAutoQuestionText1("Asigne a continuación el peso porcentual que tendrá cada competencia en la evaluación. El peso porcentual de todas las competencias debe sumar 100%. En caso de que alguna competencia no corresponda a la evaluación de algún colaborador, se redistribuirá el peso porcentual de esa competencia entre las competencias restantes.");
            setAutoQuestionText2("Asigne además el grupo de respuesta que corresponde a cada competencia. El grupo de respuesta es el conjunto de respuestas que se le presentan al evaluador para calificar al evaluado.");
        } else if (type === "leadership") {
            setTableTitle("Atributo del líder")
            setAutoQuestionTitle("Configuración de atributos del líder");
            setAutoQuestionText1("Asigne a continuación el peso porcentual que tendrá cada atributo del líder en la evaluación. El peso porcentual de todos los atributos del líder debe sumar 100%. En caso de que algún atributo del líder no corresponda a la evaluación de algún colaborador, se redistribuirá el peso porcentual de esa atributo del líder entre los atributos del líder restantes.");
            setAutoQuestionText2("Asigne además el grupo de respuesta que corresponde a cada atributo del líder. El grupo de respuesta es el conjunto de respuestas que se le presentan al evaluador para calificar al evaluado.");
        }

        if (updatedRelations.length !== relEvlCmpEag.length) {
            setRelEvlCmpEag(updatedRelations);
        }
    }, [data.evl_id]);

    const handleChange = (e) => {
        const { name, value } = e.target
        setData(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const handleChangeDate = (name, value) => {
        setData(prev => ({
            ...prev,
            [name]: value,  // value es un objeto dayjs
        }));
    };

    const handleChangeLights = (key, value, index, isMax) => {
        setData((prev) => {
            const updated = { ...prev, [key]: value };

            // Si es Max y no es el último
            if (isMax && index < colorsConfig.length - 1) {
                const nextMinKey = colorsConfig[index + 1].minKey;
                const nextMinValue = value + 0.1;

                updated[nextMinKey] = nextMinValue;
            }

            return updated;
        });
    };

    const handleChangeCommentsOption = (e) => {
        setData(prev => ({ ...prev, evl_comments_option: e.target.value }));
    }; 

    const totalIndicatorsCompetencies =
        (parseInt(data.evl_indicators_porcentage, 10) || 0) +
        (parseInt(data.evl_competencies_porcentage, 10) || 0);

    const handleChangeIndicatorsCompetencies = (name, value) => {
        // Solo permitir enteros positivos
        const parsedValue = parseInt(value, 10);
        if (!isNaN(parsedValue)) {
            setData(prev => ({
                ...prev,
                [name]: parsedValue
            }));
        } else if (value === null) {
            // Permitir limpiar el input
            setData(prev => ({
                ...prev,
                [name]: 0
            }));
        }
    };

    const handleFileUpload = (file) => {
        setSelectedFile(file[0]);
        setFileCharged(true);
    }

    const handleChangeFile = () => {
        setFileCharged(false)
    }

    const handleRelationships = (relationships) => {
        const fileData = relationships.map((item, index) => {
            const evaluatedDni = String(parseInt(item.evr_evaluated, 10));
            const evaluatorDni = String(parseInt(item.evr_evaluator, 10));

            const evaluatedInfo = dataEmployees.find(emp => String(emp.empl_dni) === evaluatedDni);
            const evaluatorInfo = dataEmployees.find(emp => String(emp.empl_dni) === evaluatorDni);

            return {
                evr_id: item.evr_id ? item.evr_id : null,
                evr_uid: `${Date.now()}_${index}`, // ID único
                evr_evaluated: evaluatedDni,
                evr_evaluated_fullname: evaluatedInfo
                    ? `${evaluatedInfo.empl_first_name} ${evaluatedInfo.empl_last_name}`
                    : "Nombre no encontrado",
                evr_evaluated_job_title: evaluatedInfo?.empl_job_title_name || "Cargo no encontrado",
                evr_evaluator: evaluatorDni,
                evr_evaluator_fullname: evaluatorInfo
                    ? `${evaluatorInfo.empl_first_name} ${evaluatorInfo.empl_last_name}`
                    : "Nombre no encontrado",
                evr_evaluator_job_title: evaluatorInfo?.empl_job_title_name || "Cargo no encontrado",
                evr_type: item.evr_type,
            };
        });

        setData(prev => ({
            ...prev,
            evl_relationships: fileData,
        }));
    };

    const handleBlurSearch = (dni, setInfo) => {
        const employee = dataEmployees.find((emp) => String(emp.empl_dni) === String(dni));
        if (!employee) {
            message.error(`No se encontró el empleado con DNI: ${dni}`);
            setInfo(null);
        } else {
            setInfo({
                fullname: `${employee.empl_first_name} ${employee.empl_last_name}`,
                job_title: employee.empl_job_title_name,
            });
        }
    };

    const handleAddRelationship = () => {
        const relationships = data.evl_relationships || [];

        if (!evaluated || !evaluator || !evrType || !evaluatedInfo || !evaluatorInfo) {
            message.warning("Completa todos los campos correctamente antes de agregar.");
            return;
        }

        const duplicate = relationships.find(
            (rel) => rel.evr_evaluated === evaluated && rel.evr_evaluator === evaluator
        );
        if (duplicate) {
            message.warning("Esta relación ya existe.");
            return;
        }

        const newRelationship = {
            evr_evaluated: evaluated,
            evr_evaluated_info: evaluatedInfo,
            evr_evaluator: evaluator,
            evr_evaluator_info: evaluatorInfo,
            evr_type: evrType,
        };

        const updatedRelationships = [...relationships, newRelationship];
        handleRelationships(updatedRelationships);
        
        message.success("Relación agregada correctamente.");

        // Limpiar inputs
        setEvaluated("");
        setEvaluator("");
        setEvrType("");
        setEvaluatedInfo(null);
        setEvaluatorInfo(null);
    };
    
    const handleDeleteRelationship = (uid) => {
        setData(prev => ({
            ...prev,
            evl_relationships: prev.evl_relationships.filter(item => item.evr_uid !== uid)
        }));
    };

    const handleReceSelectChange = (cmpId, value) => {
        setRelEvlCmpEag((prev) =>
            prev.map((rel) =>
                rel.cmp_id === cmpId ? { ...rel, eag_id: value } : rel
            )
        );
    };

    const handleReceWeightChange = (cmpId, value) => {
        setRelEvlCmpEag((prev) =>
            prev.map((rel) =>
                rel.cmp_id === cmpId ? { ...rel, weight: value } : rel
            )
        );
    };

    const handleWeightTotalChange = (total, isValid) => {
        setIsWeightValid(isValid);
    };

    const uploadFile = async () => {
        setShowLoading(true);
        setLoadingText("Procesando archivo. Esto puede tardar un poco...");

        const formData = new FormData();
        formData.append("file", selectedFile);

        const token = localStorage.getItem('access_token');

        const headers = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            },
        }

        axios
            .post(`${apiUrl}/files/process-relationships/`, formData, headers)
            .then(function (response) {
                const relationships = response.data.relationships
                handleRelationships(relationships);
                setFileCharged(false);
                setSelectedFile(null);
                setShowLoading(false);
            })
            .catch(function (error) {
                setShowLoading(false)
                showSwal(`Error: ${error}`, 0, "Error");
                console.error(`Error: ${error}`);
            });
    };

    const handleFileUploadQuestions = (file) => {
        setSelectedFileQuestions(file[0]);
        setFileChargedQuestions(true);
    }

    const handleChangeFileQuestions = () => {
        setFileChargedQuestions(false)
    }

    const uploadFileQuestions = async () => {
        setShowLoading(true);
        setLoadingText("Procesando archivo. Esto puede tardar un poco...");

        const formData = new FormData();
        formData.append("file", selectedFileQuestions);
        formData.append("type", type);

        const token = localStorage.getItem('access_token');

        const headers = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            },
        }

        axios
            .post(`${apiUrl}/files/process-questions/`, formData, headers)
            .then(function (response) {
                const questions = response.data.questions
                setFileChargedQuestions(false);
                setSelectedFileQuestions(null);
                setShowLoading(false);
                setData(prev => ({
                    ...prev,
                    evl_questions: [...(prev.evl_questions || []), ...questions],
                }));
            })
            .catch(function (error) {
                setShowLoading(false)
                showSwal(`Error: ${error}`, 0, "Error");
                console.error(`Error: ${error}`);
            });
    };

    const handleAddQuestion = () => {
        // if (!question.trim() || !questionText.trim()) {
        //     message.warning("Debe completar ambos campos");
        //     return;
        // }

        let newQuestion = {
            evq_title: "",
            evq_question: "",
            evq_eag_id: null,
        };

        if (type == "competencies" || type == "leadership") {
            newQuestion.evq_dimension = 0;
        }

        setData(prev => ({
            ...prev,
            evl_questions: [...(prev.evl_questions || []), newQuestion],
        }));

        // setQuestion("");
        // setQuestionText("");
        message.success("Pregunta agregada");
    };

    const handleQuestionChange = (index, field, value) => {
        setData(prev => {
            const updatedQuestions = [...(prev.evl_questions || [])];

            if (!updatedQuestions[index]) {
                console.warn("Índice de pregunta inválido:", index);
                return prev;
            }

            updatedQuestions[index] = {
                ...updatedQuestions[index],
                [field]: value,
            };

            return {
                ...prev,
                evl_questions: updatedQuestions,
            };
        });
    };

    const handleDeleteQuestion = (index) => {
        setData(prev => ({
            ...prev,
            evl_questions: prev.evl_questions.filter((_, i) => i !== index)
        }));
    };

    const validateBeforeSave = () => {
        // Validar campos requeridos
        const requiredFields = [
            { key: "evl_title", label: "Título" },
            { key: "evl_welcome_message", label: "Mensaje de bienvenida" },
            { key: "evl_start_date", label: "Fecha de inicio" },
            { key: "evl_finish_date", label: "Fecha de finalización" },
            { key: "evl_email_message", label: "Mensaje de correo a enviar" },
            { key: "evl_email_responsible", label: "Responsable del correo" },
            { key: "evl_email_responsible_job_title", label: "Cargo del responsable" },
            { key: "evl_email_responsible_email", label: "Email del responsable" },
            { key: "evl_final_message", label: "Mensaje final" },
            { key: "evl_comments_option", label: "Opción de comentarios" }
        ];

        for (const field of requiredFields) {
            const value = data[field.key];
            if (value === null || value === undefined || value.toString().trim() === "") {
                message.error(`El campo "${field.label}" es obligatorio`);
                return false;
            }
        }

        // Validar fechas
        const startDate = new Date(data.evl_start_date);
        const finishDate = new Date(data.evl_finish_date);
        if (isNaN(startDate) || isNaN(finishDate)) {
            message.error("Las fechas deben ser válidas");
            return false;
        }
        if (startDate >= finishDate) {
            message.error("La fecha de inicio debe ser anterior a la fecha de finalización");
            return false;
        }

        // Validar email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(data.evl_email_responsible_email)) {
            message.error("El email del responsable no es válido");
            return false;
        }

        // Validar porcentajes
        const indicators = parseInt(data.evl_indicators_porcentage, 10);
        const competencies = parseInt(data.evl_competencies_porcentage, 10);
        const total = indicators + competencies;

        if (
            isNaN(indicators) || isNaN(competencies) ||
            indicators < 0 || competencies < 0 ||
            indicators > 100 || competencies > 100
        ) {
            message.error("Los porcentajes deben ser números entre 0 y 100");
            return false;
        }

        if (total !== 100) {
            message.error("La suma de porcentajes debe ser exactamente 100");
            return false;
        }

        // Validar rangos de colores
        for (let i = 0; i < colorsConfig.length; i++) {
            const min = parseFloat(data[colorsConfig[i].minKey]);
            const max = parseFloat(data[colorsConfig[i].maxKey]);

            if (isNaN(min) || isNaN(max) || max <= min) {
                message.error(`Revisa los valores del color ${colorsConfig[i].label}`);
                return false;
            }
        }

        // Validar relaciones
        if (!data.evl_relationships || data.evl_relationships.length === 0) {
            message.error("Debe haber al menos una relación evaluador-evaluado");
            return false;
        }

        for (let [i, rel] of data.evl_relationships.entries()) {
            if (
                !rel.evr_evaluated ||
                !rel.evr_evaluator ||
                !rel.evr_type
            ) {
                message.error(`Todos los campos de la relación #${i + 1} deben estar completos`);
                return false;
            }
        }

        // Validar competencias con evaluación asociada
        for (let [i, item] of relEvlCmpEag.entries()) {
            if (
                item.eag_id === null || item.eag_id === undefined || item.eag_id === "" ||
                item.weight === null || item.weight === undefined || item.weight === ""
            ) {
                message.error(`Debe completar 'Grupo de respuesta' y 'Peso' para la competencia #${i + 1}`);
                return false;
            }
        }

        if (isWeightValid === false) {
            message.error("El peso total de las competencias debe sumar 100%");
            return false;
        }

        return true; // Todo OK
    };

    

    return (
        <Space direction="vertical" size="middle" style={{ width: '100%', margin: '0 auto' }}>
            {
                showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
            }
            
            <div style={{ marginBottom: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                    <Text strong type="secondary">Nombre de la evaluación</Text>
                    <Tooltip title="Ej: Evaluación de competencias o Valoración de Competencias.">
                        <QuestionCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                    </Tooltip>
                </div>
                <Input
                    name="evl_title"
                    value={data.evl_title || ''}
                    onChange={handleChange}
                    placeholder="Digite el nombre de la evaluación"
                />
            </div>
            
            <div style={{ marginBottom: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                    <Text strong type="secondary">Mensaje de bienvenida</Text>
                    <Tooltip title="Ej: Le agradecemos calificar cada una de las afirmaciones. Su contribución es fundamental para el éxito del proceso.">
                        <QuestionCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                    </Tooltip>
                </div>
                <Text style={{ display: 'block', marginBottom: 4 }}>
                    Digite el texto del mensaje de bienvenida a las encuestas que verán los colaboradores en el encabezado.
                </Text>
                <TextArea
                    name="evl_welcome_message"
                    autoSize={{ minRows: 2, maxRows: 5 }}
                    value={data.evl_welcome_message || ''}
                    onChange={handleChange}
                    placeholder="Digite el mensaje de bienvenida"
                />
            </div>
            
            <div style={{ marginBottom: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                    <Text strong type="secondary">Fecha de inicio y cierre del proceso</Text>
                </div>
                <Row gutter={12}>
                    <Col xs={24} sm={12}>
                        <DatePicker
                            style={{ width: '100%' }}
                            placeholder="Fecha de inicio"
                            format="DD/MM/YYYY"
                            // value={new Date(data.evl_start_date)}
                            value={data.evl_start_date ? dayjs(data.evl_start_date) : null}
                            onChange={(date) => handleChangeDate('evl_start_date', date)}
                        />
                    </Col>

                    <Col xs={24} sm={12}>
                        <DatePicker
                            style={{ width: '100%' }}
                            placeholder="Fecha de cierre"
                            format="DD/MM/YYYY"
                            value={data.evl_finish_date ? dayjs(data.evl_finish_date) : null}
                            // value={new Date(data.evl_finish_date)}
                            onChange={(date) => handleChangeDate('evl_finish_date', date)}
                        />
                    </Col>
                </Row>
            </div>
            
            <div style={{ marginBottom: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                    <Text strong type="secondary">Mensaje al final de la encuesta</Text>
                    <Tooltip title="Ej: Muchas gracias por haber participado en la evaluación. Su percepción es muy importante para nosotros.">
                        <QuestionCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                    </Tooltip>
                </div>
                <Text style={{ display: 'block', marginBottom: 4 }}>
                    Digite el texto para el mensaje que verán los colaboradores al finalizar de la encuesta.
                </Text>
                <TextArea
                    name="evl_final_message"
                    autoSize={{ minRows: 2, maxRows: 5 }}
                    value={data.evl_final_message || ''}
                    onChange={handleChange}
                    placeholder="Digite el mensaje de bienvenida"
                />
            </div>

            <div style={{ marginBottom: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                    <Text strong type="secondary">Mensaje para correo electrónico</Text>
                    {/* <Tooltip title="Ej: Muchas gracias por haber participado en la evaluación. Su percepción es muy importante para nosotros.">
                        <QuestionCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                    </Tooltip> */}
                </div>
                <Text style={{ display: 'block', marginBottom: 4 }}>
                    Digite el texto para el mensaje que verán los colaboradores al recibir el correo electrónico para acceder a los enlaces de evaluación.
                </Text>
                <TextArea
                    name="evl_email_message"
                    autoSize={{ minRows: 2, maxRows: 5 }}
                    value={data.evl_email_message || ''}
                    onChange={handleChange}
                    placeholder="Digite el mensaje del correo electrónico"
                />
            </div>

            <div style={{ marginBottom: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                    <Text strong type="secondary">Información para envío de correos electrónicos</Text>
                    {/* <Tooltip title="Ej: Muchas gracias por haber participado en la evaluación. Su percepción es muy importante para nosotros.">
                        <QuestionCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                    </Tooltip> */}
                </div>
                <Text style={{ display: 'block', marginBottom: 4 }}>
                    Digite los datos del responsable de enviar los correos electrónicos. Esta información se usará para enviar los correos electrónicos a los evaluadores y evaluados.
                </Text>
                <Input
                    name="evl_email_responsible"
                    value={data.evl_email_responsible}
                    onChange={handleChange}
                    placeholder="Nombre del responsable"
                    style={{ marginBottom: 8 }}
                />
                <Input
                    name="evl_email_responsible_job_title"
                    value={data.evl_email_responsible_job_title}
                    onChange={handleChange}
                    placeholder="Cargo del responsable"
                    style={{ marginBottom: 8 }}
                />
                <Input
                    name="evl_email_responsible_email"
                    value={data.evl_email_responsible_email}
                    onChange={handleChange}
                    placeholder="Correo electrónico del responsable"
                />
            </div>
            
            <div style={{ marginBottom: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                    <Text strong type="secondary">Configuración del sermáforo</Text>
                    <Tooltip title="Ej: Rojo: 0%-60%, Amarillo: 60.1%-75%, Verde: 75.1%-90%, Azul: 90.1%-100%">
                        <QuestionCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                    </Tooltip>
                </div>
                <Text style={{ display: 'block', marginBottom: 4 }}>
                    Configure a continuación los rangos de cada color del semáforo. El rango de cada color debe ser diferente y no puede haber rangos vacíos. El rango de cada color debe ser menor al rango del siguiente color.
                </Text>
                <>
                    {colorsConfig.map(({ color, label, minKey, maxKey }, index) => (
                        <Row key={color} align="middle" gutter={8} style={{ marginBottom: 12 }}>
                            <Col>
                                <Tag color={color} style={{ width: 100, padding: '4px 12px', fontWeight: 'bold' }}>
                                    {label}
                                </Tag>
                            </Col>
                            <Col>
                                <Text strong>Min:</Text>
                                <InputNumber
                                    value={data[minKey]}
                                    readOnly
                                    style={{ width: 100, marginLeft: 4 }}
                                />
                            </Col>
                            <Col>
                                <Text strong>Max:</Text>
                                <InputNumber
                                    value={data[maxKey]}
                                    onChange={(value) => handleChangeLights(maxKey, value, index, true)}
                                    min={parseFloat((data[color.minKey] + 0.1).toFixed(1))}
                                    max={100}
                                    step={0.1}
                                    style={{ width: 100, marginLeft: 4 }}
                                    readOnly={index === colorsConfig.length - 1} // Solo el último campo es editable
                                />
                            </Col>
                        </Row>
                    ))}
                </>
            </div>

            
            <div style={{ marginBottom: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                    <Text strong type="secondary">
                        {autoQuestionTitle}
                    </Text>
                </div>
                <Text style={{ display: 'block', marginBottom: 4 }}>
                    {autoQuestionText1}
                </Text>
                <Text style={{ display: 'block', marginBottom: 4 }}>
                    {autoQuestionText2}
                </Text>
                {
                    type === "competencies" && <TableCompetenceAnswerGroupRelation relEvlCmpEag={relEvlCmpEag} dataEvaluationAnswerGroups={dataEvaluationAnswerGroups} handleSelectChange={handleReceSelectChange} handleWeightChange={handleReceWeightChange} onWeightTotalChange={handleWeightTotalChange} title={tableTitle} />
                }
                {
                    type === "leadership" && <TableAttributeAnswerGroupRelation relEvlCmpEag={relEvlCmpEag} dataEvaluationAnswerGroups={dataEvaluationAnswerGroups} handleSelectChange={handleReceSelectChange} handleWeightChange={handleReceWeightChange} onWeightTotalChange={handleWeightTotalChange} title={tableTitle} />
                }
                
            </div>
            
            <div style={{ marginBottom: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                    <Text strong type="secondary">Peso de competencias vs indicadores</Text>
                </div>
                <Text style={{ display: 'block', marginBottom: 4 }}>
                    Aisgne a continuación el peso porcentual que tendrá esta evaluación de competencias frente a la evaluación de indicadores. El peso porcentual de ambas evaluaciones debe sumar 100%.
                </Text>
                <br></br>
                <Row gutter={[24, 16]}>
                    <Col>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginBottom: 4 }}>Indicadores (%)</label>
                            <InputNumber
                                min={0}
                                max={100}
                                step={1}
                                value={data.evl_indicators_porcentage}
                                onChange={(value) =>
                                    handleChangeIndicatorsCompetencies("evl_indicators_porcentage", value)
                                }
                            />
                        </div>
                    </Col>

                    <Col>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginBottom: 4 }}>Competencias (%)</label>
                            <InputNumber
                                min={0}
                                max={100}
                                step={1}
                                value={data.evl_competencies_porcentage}
                                onChange={(value) =>
                                    handleChangeIndicatorsCompetencies("evl_competencies_porcentage", value)
                                }
                            />
                        </div>
                    </Col>

                    <Col>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginBottom: 4 }}>Total</label>
                            <Tag
                                color={totalIndicatorsCompetencies === 100 ? "green" : "red"}
                                style={{
                                    width: 60,
                                    height: 32,
                                    lineHeight: "32px",
                                    textAlign: "center",
                                    padding: 0,
                                }}
                            >
                                {totalIndicatorsCompetencies}%
                            </Tag>
                        </div>
                    </Col>
                </Row>
            </div>

            <div style={{ marginBottom: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                    <Text strong type="secondary">Comentarios para el evaluado del evaluador</Text>
                </div>
                <Text style={{ display: 'block', marginBottom: 4 }}>
                    Elija la opción que desee configurar para agregar campos de comentarios para el evaluador.
                </Text>
                <Radio.Group
                    onChange={handleChangeCommentsOption}
                    value={data.evl_comments_option}
                    style={{ display: 'flex', flexDirection: 'column', marginTop: 8 }}
                >
                    <Radio value={1}>Por comportamiento</Radio>
                    <Radio value={2}>Por competencia</Radio>
                    <Radio value={3}>Al final de la evaluación</Radio>
                </Radio.Group>
            </div>
            
            <div style={{ marginBottom: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                    <Text strong type="secondary">Relaciones evaluador-evaluado</Text>
                    {/* <Tooltip title="Ej: Muchas gracias por haber participado en la evaluación. Su percepción es muy importante para nosotros.">
                        <QuestionCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                    </Tooltip> */}
                </div>
                <Text style={{ display: 'block', marginBottom: 4 }}>
                    A continuación puede realizar la carga de las relaciones Evaluador - Evaluado. Puede usar el cargador de archivo para cargar las relaciones arrastrando el archivo o dando click en el cargador y luego dando click en "Cargar relaciones".
                </Text>
                <div className='display-center-row display-center-column align-full-center'>
                    <div style={{ width: "80%", backgroundColor: "white" }} className='display-center-row main-subcontainer'>
                        {
                            fileCharged ? <div className='display-center-row display-center-column align-full-center uploader-container' >
                                <p className='filename-tag'>{selectedFile.name}</p>
                                <Button style={{ width: 'auto' }} type="primary" danger onClick={handleChangeFile} icon={<SyncOutlined />}>Cambiar archivo</Button>
                            </div> : <div className='display-center-row display-center-column uploader-container'>
                                <FileUploaderAuto mostrarData={handleFileUpload} multi={false} openSwal={showSwal} uploadFile={true} tamanoArchivo={100} />
                            </div>
                        }
                    </div>
                    <Button style={{ width: 'auto', marginBottom: 25 }} type="primary" onClick={uploadFile} disabled={!fileCharged} icon={<UploadOutlined />}>Cargar relaciones</Button>
                    <Text style={{ width: '100%', display: 'block', marginBottom: 25 }}>
                        Si desea cargar las relaciones manualmente, complete los campos y haga clic en el botón "Agregar relación".
                    </Text>
                    <Form layout="vertical" style={{ width: "100%" }}>
                        <Row gutter={16}>
                            {/* Columna del evaluado */}
                            <Col span={8}>
                                <Form.Item label="Evaluado (DNI)">
                                    <Input
                                        value={evaluated}
                                        onChange={(e) => setEvaluated(e.target.value)}
                                        onBlur={() => handleBlurSearch(evaluated, setEvaluatedInfo)}
                                        placeholder="DNI del evaluado"
                                    />
                                </Form.Item>
                                <Form.Item label="Nombre del Evaluado">
                                    <Input value={evaluatedInfo?.fullname || ""} readOnly />
                                </Form.Item>
                                <Form.Item label="Cargo del Evaluado">
                                    <Input value={evaluatedInfo?.job_title || ""} readOnly />
                                </Form.Item>
                            </Col>

                            {/* Columna del evaluador */}
                            <Col span={8}>
                                <Form.Item label="Evaluador (DNI)">
                                    <Input
                                        value={evaluator}
                                        onChange={(e) => setEvaluator(e.target.value)}
                                        onBlur={() => handleBlurSearch(evaluator, setEvaluatorInfo)}
                                        placeholder="DNI del evaluador"
                                    />
                                </Form.Item>
                                <Form.Item label="Nombre del Evaluador">
                                    <Input value={evaluatorInfo?.fullname || ""} readOnly />
                                </Form.Item>
                                <Form.Item label="Cargo del Evaluador">
                                    <Input value={evaluatorInfo?.job_title || ""} readOnly />
                                </Form.Item>
                            </Col>

                            {/* Columna del tipo de relación y botón */}
                            <Col span={8}>
                                <Form.Item label="Tipo de relación">
                                    <Input
                                        value={evrType}
                                        onChange={(e) => setEvrType(e.target.value.toUpperCase())}
                                        placeholder="Ej: AUTOEVALUACION"
                                    />
                                </Form.Item>
                                <Form.Item label=" ">
                                    <Button
                                        type="primary"
                                        onClick={handleAddRelationship}
                                        block
                                        style={{ marginTop: 8 }}
                                        icon={<PlusOutlined />}
                                    >
                                        Agregar relación
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    {
                        data["evl_relationships"] && data.evl_relationships.length > 0 && <TableRelationships
                            isLinks={false}
                            evl_relationships={data.evl_relationships}
                            handleDeleteRelationship={handleDeleteRelationship}
                            evl_id={data.evl_id}
                        />
                    }

                </div>
            </div>

            <div style={{ marginBottom: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                    <Text strong type="secondary">Preguntas adicionales</Text>
                    {/* <Tooltip title="Ej: Muchas gracias por haber participado en la evaluación. Su percepción es muy importante para nosotros.">
                        <QuestionCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                    </Tooltip> */}
                </div>
                <Text style={{ display: 'block', marginBottom: 4 }}>
                    A continuación, puede agregar preguntas adicionales que desea que el evaluador responda al finalizar la evaluación.
                </Text>
                <Text style={{ display: 'block', marginBottom: 4 }}>
                    Puede hacerlo a través del cargador de archivos que encontrará a continuación, o bien, puede agregar preguntas manualmente.
                </Text>
                <div className='display-center-row display-center-column align-full-center'>
                    <div style={{ width: "80%", backgroundColor: "white" }} className='display-center-row main-subcontainer'>
                        {
                            fileChargedQuestions ? <div className='display-center-row display-center-column align-full-center uploader-container' >
                                <p className='filename-tag'>{selectedFileQuestions.name}</p>
                                <Button style={{ width: 'auto' }} type="primary" danger onClick={handleChangeFileQuestions} icon={<SyncOutlined />}>Cambiar archivo</Button>
                            </div> : <div className='display-center-row display-center-column uploader-container'>
                                <FileUploaderAuto mostrarData={handleFileUploadQuestions} multi={false} openSwal={showSwal} uploadFile={true} tamanoArchivo={100} />
                            </div>
                        }
                    </div>
                    <Button style={{ width: 'auto', marginBottom: 25 }} type="primary" onClick={uploadFileQuestions} disabled={!fileChargedQuestions} icon={<UploadOutlined />}>Cargar preguntas</Button>
                </div>
                <Text style={{ display: 'block', marginBottom: 4 }}>
                    Para agregar una pregunta manualmente, haga click en "Agregar pregunta". Esto añadirá la pregunta a la tabla que se encuentra debajo del botón, donde deberá ingresar el título y el texto de la pregunta.
                </Text>
                <Text style={{ display: 'block', marginBottom: 4 }}>
                    Asigne además el grupo de respuesta que corresponde a cada pregunta. El grupo de respuesta es el conjunto de respuestas que se le presentan al evaluador para calificar al evaluado.
                </Text>
                {/* <div className='display-center-row display-center-column align-full-center'>
                    <Form layout="vertical" style={{ width: "100%", marginBottom: 25 }}>
                        <Space direction="vertical" style={{ width: "100%" }}>
                            <Form.Item label="Pregunta">
                                <TextArea
                                    value={question}
                                    onChange={(e) => setQuestion(e.target.value)}
                                    rows={2}
                                    placeholder="Título de la pregunta"
                                />
                            </Form.Item>

                            <Form.Item label="Texto de apoyo">
                                <TextArea
                                    value={questionText}
                                    onChange={(e) => setQuestionText(e.target.value)}
                                    rows={2}
                                    placeholder="Ingrese texto de la pregunta"
                                />
                            </Form.Item>

                            <Button type="primary" onClick={handleAddQuestion}>
                                Agregar pregunta
                            </Button>
                        </Space>
                    </Form>
                </div> */}
                <div className='display-center-row display-center-column align-full-center'>
                    <Button type="primary" onClick={handleAddQuestion} icon={<PlusOutlined />} style={{ marginBottom: 16, marginTop: 8 }}>
                        Agregar pregunta
                    </Button>
                </div>
                <TableEvaluationQuestions evlQuestions={data.evl_questions} dataEvaluationAnswerGroups={dataEvaluationAnswerGroups} handleSelectChange={handleQuestionChange} handleDeleteQuestion={handleDeleteQuestion} />
            </div>

            <Space style={{ justifyContent: 'flex-end', width: '100%' }}>
                <Button onClick={onCancel}>Cancelar</Button>
                <Button type="primary" onClick={() => validateBeforeSave() && onSave()}>
                    {data.evl_id ? "Actualizar evaluación" : "Crear evaluación"}
                </Button>
            </Space>
        </Space>
    );
};

export default FormEvaluation;
